import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    serviceList: string[];
    selectedCountry?: string;
    showDisclosureStatus?: any;
    wyntkCss?: any;
    isWhiteLabel?: any;
}

const WhatYouNeedToKnow: React.FunctionComponent<IProps> = (props) => {
    const [show, setShow] = useState(true);
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const productListToShowThisSection = [
        "SVC-CRDSCORE-1B", //Quarterly Credit Score
        "SVC-CRDSCORE-1B-MONTHLY", //Monthly Credit Score
        "SVC-CRDSCORE-1B-PARENT", //Credit Score
        "SVC-EXP-MCST", //Credit Score Tracker
        "SVCLVL-CRDRPT-3B-SCORE", //3-Bureau Credit Report & Score
        "SVCLVL-CRDRPT-EQUI-SCORE", //Equifax Credit Report with Score
        "SVCLVL-CRDRPT-EXP-SCORE", //Experian Credit Report with Score
        "SVCLVL-CRDRPT-TRANS-SCORE", //Experian Credit Report with Score
        "SVCLVL-CS-TU-CRDSCORE-VTG-1B", //Credit Score
        "SVCLVL-EXP-ACRDRPT-3B-SCORE", //3-Bureau Annual Credit Report & Score
        "SVCLVL-EXP-ACRDRPT-SCORE", //1-Bureau Annual Credit Report & Score
        "SVCLVL-EXP-OTCRDRPT-3B-SCORE", //3-Bureau One Time Credit Report & Score
        "SVCLVL-EXP-OTCRDRPT-SCORE", //1-Bureau One Time Credit Report & Score
        "SVCLVL-TU-ACRDRPT-3B-SCORE", //3-Bureau Annual Credit Report & Score
        "SVCLVL-TU-ACRDRPT-SCORE", //1-Bureau Annual Credit Report & Score
        "SVCLVL-TU-CRDRPT-3B-SCORE", //3-Bureau Credit Report & Score
        "SVCLVL-TU-CRDRPT-SCORE", //1-Bureau Credit Report & Score
        "SVCLVL-TU-DCRDRPT-SCORE", //1-Bureau Daily Credit Report & Score
        "SVCLVL-TU-MCRDRPT-3B-SCORE", //3-Bureau Monthly Credit Report & Score
        "SVCLVL-TU-MCRDRPT-SCORE", //1-Bureau Monthly Credit Report & Score
        "SVCLVL-TU-QCRDRPT-3B-SCORE", //3-Bureau Quarterly Credit Report & Score
        "SVCLVL-TU-QCRDRPT-SCORE", //1-Bureau Quarterly Credit Report & Score
        "SVC-TU-ACRDSCORE-1B", //Annual Credit Score
        "SVC-TU-CRDRPT-SCORE-1B-ONETIME", //1B Credit Report & Score
        "SVC-TU-CRDRPT-SCORE-3B-ONETIME", //3B Credit Report & Score
        "SVC-TU-CSS", //Credit Score Simulator
        "SVC-TU-CST", //Credit Score Tracker
        "SVC-TU-DCRDSCORE-1B", //Daily Credit Score
        "SVC-TU-MCRDSCORE-1B", //Monthly Credit Score
        "SVC-TU-QCRDSCORE-1B", //Quarterly Credit Score
        "three-bureau-credit-monitoring", //IDF credit services
        "three-bureau-credit-report",
        "three-bureau-credit-score",
        "trans-union-credit-monitoring",
        "trans-union-credit-report",
        "trans-union-credit-score",
        "credit-score-simulator",
        "credit-score-monitoring",
        "advanced-fraud-monitoring",
        "single-bureau-enhanced-alerts-bundle",
        "three-bureau-enhanced-alerts-bundle",
        "credit-report-authorization"
    ];

    useEffect(() => {
        let found = false;
        props.serviceList.forEach((service) => {
            if (service != null && service.trim().length > 0 && service !== "--") {
                if (!found) {
                    found = productListToShowThisSection.find((element) => element === service) != null;
                }
            }
        });
        setShow(found);
        if (props?.showDisclosureStatus) {
            props.showDisclosureStatus(found);
        }
    }, [props]);

    return (
        <>
            {show && props.selectedCountry === "US" && (
                <div id="wyntk-box" style={{ marginTop: "15px" }}>
                    <div className="box-header">
                        {!props.isWhiteLabel && props.wyntkCss ? null :
                            <> <div className="margin-bottom-l"></div>
                                <hr />
                                <div className="margin-bottom-l"></div>
                            </>
                        }
                    </div>
                    <div className="box-content">
                        <p dangerouslySetInnerHTML={{ __html: tLang("manageAccount.protectionPlan.whatYouNeedtoKnow.Text") }}></p>
                    </div>
                </div>
            )}
        </>
    );
};

export default WhatYouNeedToKnow;
